import { getLocaleFromPath } from '../../utils/localeHelpers'

// Send beacon to our server - to track Sponsored Listing daily impressions
// To be used as ranking on special Sponsored Algolia index
// To give all items same chance of being shown
export function trackSponsoredListingImpression (listingIds) {
  const data = new FormData()

  const ids = Array.isArray(listingIds) ? listingIds : String(listingIds).split(',')
  ids.map((id) => String(id).trim()).filter(Boolean).forEach((id) => {
    data.append('listing_ids[]', id)
  })

  data.append('locale', getLocaleFromPath(window.location.pathname) || 'en')

  navigator.sendBeacon('/beacons/sponsored_listing_impressions', data)
}
